import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UserService } from './core/services/user.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthValidationInterceptor } from './core/services/auth-validation';
import { AllErrorHandler } from './errorhandling/errorhandler';
import { SettingsService } from './core/services/settings.service';
import { DatePipe } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { DefaultModule } from './layouts/default/default.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    DefaultModule,
    FormsModule
  ],
  providers: [
    {
      provide: UserService,
    },
    {
      provide: SettingsService,
    },
    {
      provide: ErrorHandler,
      useClass: AllErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthValidationInterceptor,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: 'de-DE',
    },
    {
      provide:DatePipe
    },
    {
      provide: MatDialogRef,
      useValue: {}
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
